import {schema} from 'normalizr';
const customFieldSchema = new schema.Entity('customField');
const customFieldOptionSchema = new schema.Entity('customFieldOption');
const sportSchema = new schema.Entity('sport');
const amenitySchema = new schema.Entity('amenity');
const resourceTypeSchema = new schema.Entity('resourceType');
const resourceSchema = new schema.Entity('resource');
const notificationSchema = new schema.Entity('notification');
const partnerSchema = new schema.Entity('partner');
const clientSchema = new schema.Entity('client');
const facilitySchema = new schema.Entity('facility');
const serviceSchema = new schema.Entity('service');
const reservationSchema = new schema.Entity('reservation');
const reservationCycleSchema = new schema.Entity('reservationCycle');
const facilityTypeSchema = new schema.Entity('facilityType')
const openingHourSchema = new schema.Entity('openingHour');
const inavailabilityHourSchema = new schema.Entity('inavailabilityHour');
const paymentSchema = new schema.Entity('payment');
const paymentTypeSchema = new schema.Entity('paymentType');
const addressSchema = new schema.Entity('address');
const businessSchema = new schema.Entity('business');
const imageSchema = new schema.Entity('image');
const roleSchema = new schema.Entity('role');
const permissionSchema = new schema.Entity('permission');
const languageSchema = new schema.Entity('language');
const paymentMethodSchema = new schema.Entity('paymentMethod');
const blockSchema = new schema.Entity('block');
const seasonSchema = new schema.Entity('season');
const facilityPartSchema = new schema.Entity('facilityPart');

businessSchema.define({
    address: addressSchema,
    sports: [sportSchema],
    amenities: [amenitySchema],
    openingHours: [openingHourSchema],
    images: [imageSchema],
    logo: imageSchema
});
resourceSchema.define({
    type: resourceTypeSchema,
    facilities: [facilitySchema],
    openingHours: [openingHourSchema],
    services: [serviceSchema],
});
paymentSchema.define({
    paymentType: paymentTypeSchema
});
facilityTypeSchema.define({
    resource_types: [resourceTypeSchema],
    custom_fields: [customFieldSchema]
});
customFieldSchema.define({
    options: [customFieldOptionSchema]
});
facilityPartSchema.define({
    facility: facilitySchema
});
facilitySchema.define({
    address: addressSchema,
    type: facilityTypeSchema,
    openingHours: [openingHourSchema],
    services: [serviceSchema],
    resources: [resourceSchema],
    partners: [partnerSchema],
    inavailability_hours: [inavailabilityHourSchema],
    images: [imageSchema],
    custom_field_values: [customFieldOptionSchema],
    parts: [facilityPartSchema]
});
serviceSchema.define({
    facilities: [facilitySchema],
    resourceTypes: [resourceTypeSchema],
    partners: [partnerSchema],
    resources: [resourceSchema],
});
partnerSchema.define({
    openingHours: [openingHourSchema],
    services: [serviceSchema],
    facilities: [facilitySchema],
    inavailability_hours: [inavailabilityHourSchema],
    business: businessSchema,
    roles: [roleSchema],
    language: languageSchema
});
reservationSchema.define({
    partner: partnerSchema,
    client: clientSchema,
    service: serviceSchema,
    facility: facilitySchema,
    partners: [partnerSchema],
    payments: [paymentSchema],
    resources: [resourceSchema],
    reservation_cycle: reservationCycleSchema,
    facilityParts: [facilityPartSchema]
});
reservationCycleSchema.define({
    service: serviceSchema,
    client: clientSchema,
    resources: [resourceSchema],
    reservations: [reservationSchema],
    facilityParts: [facilityPartSchema]
})
blockSchema.define({
    partners: [partnerSchema],
    business: businessSchema,
    resources: [resourceSchema],
    facilities: [facilitySchema],
    facilityParts: [facilityPartSchema]
});
roleSchema.define({
    permissions: [permissionSchema]
});
facilityTypeSchema.define({
    resource_types: [resourceTypeSchema]
});

export default {
    businessSchema,
    resourceTypeSchema,
    resourceSchema,
    notificationSchema,
    partnerSchema,
    clientSchema,
    facilitySchema,
    addressSchema,
    serviceSchema,
    reservationSchema,
    facilityTypeSchema,
    openingHourSchema,
    inavailabilityHourSchema,
    paymentSchema,
    paymentTypeSchema,
    imageSchema,
    roleSchema,
    permissionSchema,
    languageSchema,
    sportSchema,
    amenitySchema,
    paymentMethodSchema,
    blockSchema,
    reservationCycleSchema,
    seasonSchema,
    facilityPartSchema
};